var map = {
	"./2hires.jpg": 775,
	"./ahires.jpg": 2028,
	"./back/1.jpg": 4323,
	"./back/2.jpg": 8866,
	"./back/3.jpg": 4220,
	"./back/4.jpg": 9559,
	"./back/5.jpg": 4267,
	"./front/1.jpg": 9779,
	"./front/2-9.jpg": 4837,
	"./front/3-6.jpg": 4286,
	"./front/4.jpg": 1924,
	"./front/5.jpg": 6555,
	"./front/7.jpg": 5533,
	"./front/8.jpg": 5980,
	"./gira.png": 3220,
	"./hires.jpg": 7478,
	"./home-vecchiodormiente.jpg": 6756,
	"./home-vecchiodormiente_old.jpg": 5744,
	"./identikit/1.jpg": 62,
	"./identikit/2.jpg": 8183,
	"./identikit/3.jpg": 3686,
	"./identikit/4.jpg": 7233,
	"./identikit/5.jpg": 4303,
	"./identikit/6.png": 3121,
	"./identikit/7.jpg": 3034,
	"./intro-vecchiodormiente.png": 1143,
	"./map.svg": 2830,
	"./scopri.jpg": 9677,
	"./visivalab.png": 8919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;